export default {
  "shoes": "Shoes",
  "hoodies": "Hoodies/Sweaters",
  "tshirts": "T-Shirts",
  "jackets": "Jackets",
  "pants": "Pants/Shorts",
  "headwear": "Headwear",
  "sets": "Sets",
  "underwear": "Underwear/Underpants",
  "jersey": "Jersey",
  "accessories": "Accessories",
  "bags": "Bags",
  "belts": "Belts",
  "perfumes": "Perfumes",
  "other": "Other Stuff",
  "view": "View",
  "tag.shoes": "Footwear",
  "tag.hoodies": "Tops",
  "tag.tshirts": "Tops",
  "tag.jackets": "Outerwear",
  "tag.pants": "Bottoms",
  "tag.headwear": "Accessories",
  "tag.sets": "Outfits",
  "tag.underwear": "Basics",
  "tag.jersey": "Sportswear",
  "tag.accessories": "Extras",
  "tag.bags": "Carry",
  "tag.belts": "Accessories",
  "tag.perfumes": "Fragrance",
  "tag.other": "More"
};